import acceptedCookiePolicy from '../../components/onetrust/cookiePolicy';
/*
* Get UTM from url
 */

const hasMarketoOrGreenhouseCookie = () => {
    const mktoUtmCookie = Cookies.get('mkto_utms');
    const mktoGCLIDCookie = Cookies.get('mkto_gclid');
    const mktoCPCCookie = Cookies.get('mkto_utms_cpc');
    const ghCookie = Cookies.get('gh_src');
    return  mktoUtmCookie || mktoGCLIDCookie || mktoCPCCookie || ghCookie;
};

const hasMarketoOrGreenhouseParams = () => {
    const urlParam = window.location.search;
    return urlParam.indexOf('utm_') > -1 || urlParam.indexOf('gclid=') > -1  || urlParam.indexOf('gh_src') > -1;
};

const hasConversionRateParams = () => {
    /*
    * Conversion rate field example: CRO1__c
     */
    const urlParam = window.location.search.toLowerCase();

    return urlParam.includes('cro');
};

const referrer = document.referrer;
const searchEngines = [ 'google','bing','yahoo','yandex','baidu','duckduckgo','aol','qwant','search.brave','ecosia','perplexity.ai','phind','you.com'];

const hasSearchEngineReferrer = () => {
    for (let engine of searchEngines) {
        if (referrer.includes(engine)) {
            return true;
        }
    };
};

const loadUtmScripts = (id) => {
    if(typeof loadJS !== 'undefined' && !document.getElementById(`${id}`)) {
        loadJS(`/public/js/external/mktoUtms.js?v={APPVEYOR_BUILD_VERSION}`, null, null, null, `${id}`, false);
    }
};

const initGetUtmFromUrl = () => {
    if(hasMarketoOrGreenhouseCookie() || hasMarketoOrGreenhouseParams() || hasConversionRateParams() || hasSearchEngineReferrer()) {
        acceptedCookiePolicy({
            ifTargetingCookies: () => {
                if(typeof loadUtmScripts !== 'undefined') {
                    loadUtmScripts('mkto-utm-js');
                }
            }
        });
    }
};

export default initGetUtmFromUrl;